import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageSelectionService } from '@web-desktop/components/menu-top/controllers/language-selection/language-selection.service';
import { ButtonDirective } from 'primeng/button';
import { map } from 'rxjs';

@Component({
  selector: 'iu-status-page-layout',
  standalone: true,
  imports: [NgOptimizedImage, TranslateModule, ButtonDirective],
  templateUrl: './status-page-layout.component.html',
  styleUrl: './status-page-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'status-page-layout',
  },
})
export default class StatusPageLayoutComponent {
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);
  private readonly languageSelectionService = inject(LanguageSelectionService);

  readonly data = toSignal(
    this.route.queryParams.pipe(
      map((data) => {
        return {
          message: data?.['message'] ?? 'status-page.lost',
          askForRefresh: data?.['askForRefresh'] ?? false,
        };
      })
    )
  );

  readonly noMessage = input(false);

  readonly message = computed(() => this.data().message);
  readonly askForRefresh = computed(() => this.data().askForRefresh);

  constructor() {
    const currentLanguage = this.languageSelectionService.getCurrentLanguage();
    this.languageSelectionService.initLanguages(currentLanguage?.iso_code);
  }

  defaultAction(): void {
    if (this.askForRefresh()) {
      localStorage.clear();
      window.location.reload();
    } else {
      this.router.navigate(['/dashboard']);
    }
  }
}
